// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__KrH1H","productName":"Table_productName__punFV"};